import React from 'react';
import {Datagrid, Filter, List, TextField, TextInput} from 'react-admin';

const CompanyFilter = (props) => (
    <Filter {...props}>
        <TextInput label="ra.action.search" source="q" alwaysOn/>
    </Filter>
);

export const QuestionGroupList = props => (
    <List filters={<CompanyFilter/>} {...props} exporter={false}>
        <Datagrid rowClick="edit">
            <TextField source="id"/>
            <TextField source="title"/>
            <TextField source="description"/>
        </Datagrid>
    </List>
);

export default QuestionGroupList
